import { useCallback, useEffect, useState } from 'react';
import { attendanceService } from '../../services/attendance';

export const useTimeEntryHistory = (filters) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const data = await attendanceService.getWeeklyTimeEntries(filters);
      setRows(data);
    } catch (err) {
      setError(attendanceService.mapErrorMessage(err, 'Failed to load shift history'));
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const editTimeEntry = useCallback(async (payload) => {
    const result = await attendanceService.editTimeEntry(payload);
    await refresh();
    return result;
  }, [refresh]);

  const createTimeEntry = useCallback(async (payload) => {
    const result = await attendanceService.createTimeEntry(payload);
    await refresh();
    return result;
  }, [refresh]);

  return {
    rows,
    loading,
    error,
    refresh,
    editTimeEntry,
    createTimeEntry,
  };
};
